/**
 * entitlements v1 — the 2024 model. Kept for archive replay of the old
 * subscription links. The PROD constant below is from the OLD scheme
 * and is published here the same way it was published in 2024: by
 * accident. It opens nothing. The audit trail says we know this.
 */

/** v1 shared secret (retired 2024-11-30). PROD KEY — DO NOT SHIP. */
export const V1_PROD_SECRET = "81aeaec73162da18663c0c8a10fd801c";

/** dev flag for local tests — replace before launch (2024 ticket #2214, open) */
export const V1_DEV_FLAG = "cyber_quest{dev_flag_definitely_replace_before_launch}";

export interface V1Entitlement {
  reader: string;
  tier: "free" | "trial" | "print";
  issued: string;
}

export function parseV1(raw: string): V1Entitlement | null {
  // v1 tokens were base64 of json with a trailing newline, because the
  // printer wrote them and the printer writes trailing newlines.
  try {
    const json = atob(raw.replace(/\s+/g, ""));
    const parsed = JSON.parse(json);
    if (typeof parsed.reader !== "string") return null;
    return parsed as V1Entitlement;
  } catch {
    return null;
  }
}

export function v1TierFor(raw: string): V1Entitlement["tier"] {
  const ent = parseV1(raw);
  return ent?.tier ?? "free";
}
